import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, } from '@/components/ui/dialog';
import { Percent } from 'lucide-react';
/**
 * Small animated dialog for editing the global tax rate.
 * Uses the shared Radix Dialog (fade + zoom entrance/exit built in).
 */
export function MCTaxDialog({ open, onOpenChange, currentRate, onSave }) {
    const [value, setValue] = useState(String(currentRate));
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (open) {
            setValue(String(currentRate));
            setError(null);
            setSaving(false);
        }
    }, [open, currentRate]);
    const handleSave = async () => {
        const rate = parseFloat(value);
        if (Number.isNaN(rate) || rate < 0 || rate > 100) {
            setError('Enter a rate between 0 and 100');
            return;
        }
        setSaving(true);
        setError(null);
        try {
            await onSave(rate);
            onOpenChange(false);
        }
        catch (err) {
            setError(err?.message || 'Failed to save');
        }
        finally {
            setSaving(false);
        }
    };
    return (_jsx(Dialog, { open: open, onOpenChange: onOpenChange, children: _jsxs(DialogContent, { className: "mc-dialog-content sm:max-w-[360px] duration-300 data-[state=open]:slide-in-from-top-4 data-[state=closed]:slide-out-to-top-4", children: [_jsxs(DialogHeader, { children: [_jsxs(DialogTitle, { className: "text-white flex items-center gap-2", children: [_jsx(Percent, { className: "h-4 w-4 text-[color:var(--mc-cyan)]" }), "Global Tax Rate"] }), _jsx(DialogDescription, { className: "text-[color:var(--mc-text-meta,#94a3b8)]", children: "Applied to all bookings and menu orders." })] }), _jsxs("div", { className: "flex items-center gap-3 py-2", children: [_jsx("input", { autoFocus: true, type: "number", value: value, onChange: (e) => setValue(e.target.value), onKeyDown: (e) => {
                                if (e.key === 'Enter')
                                    handleSave();
                            }, className: "mc-input flex-1 text-xl font-semibold mc-mono tabular-nums", step: "0.1", min: "0", max: "100" }), _jsx("span", { className: "mc-meta text-lg", children: "%" })] }), error && (_jsx("p", { className: "text-[color:var(--mc-text-accent-pink,#ff5caa)] text-xs mc-mono", children: error })), _jsxs(DialogFooter, { className: "sm:justify-end gap-2", children: [_jsx("button", { type: "button", className: "mc-btn", onClick: () => onOpenChange(false), disabled: saving, children: "Cancel" }), _jsx("button", { type: "button", className: "mc-btn mc-btn-primary", onClick: handleSave, disabled: saving, children: saving ? 'Saving…' : 'Save' })] })] }) }));
}
